import * as yup from 'yup'

function questionKeys(count) {
  return Array.from({ length: count }, (_, index) => `motivationQuestion${index + 1}`)
}

function questionFields(count, required = false) {
  return Object.fromEntries(
    questionKeys(count).map((key, index) => {
      let schema = yup.string().label(`Question ${index + 1}`)
      if (required) schema = schema.required('Réponse requise')
      return [key, schema]
    })
  )
}

/**
 * Cover letter validation schema (file, questions, or both).
 * @param {boolean} [required]
 * @param {string} [letterMode]
 * @param {object} [fileOptions]
 * @param {number} questionCount Number of motivation questions configured by the employer
 * @returns {import('yup').ObjectSchema<any>} Yup object schema for the letter fields
 */
export default function coverLetterSchema(required = false, letterMode = 'both', fileOptions = {}, questionCount) {
  let letterField = yupFile(fileOptions).nullable().label('Lettre de motivation')

  // PDF only (questions unavailable)
  if (letterMode === 'file') {
    if (required) letterField = letterField.required('Lettre de motivation requise')
    return yup.object({ letter: letterField })
  }

  // Every answer required (PDF generated on submit)
  if (letterMode === 'questions') {
    return yup.object({ ...questionFields(questionCount, true) })
  }

  // Either an uploaded letter OR every answer
  return yup.object({
    letter: letterField.test('letter-or-questions', 'Joignez une lettre de motivation ou répondez aux questions de motivation', function (value) {
      return !!value || questionKeys(questionCount).every(key => !!this.parent[key])
    }),
    ...questionFields(questionCount)
  })
}
